(() => {
  const slider = document.querySelector(".wb-slider-content");
  const dropzones = document.querySelector(".wb-dropzones");
  const collectionsDDL = document.querySelector(".wb-collections");
  const collectionTitle = document.querySelector(".wb-collection-title");
  const canvas = document.querySelector(".wb-canvas");
  const quickview = document.querySelector(".wb-quickview");
  /** @type {Record<string, {hasMore: boolean, products: Array<{id: string, title: string, featured_image: {aspect_ratio: number, url: string}}>}>} */
  const collectionCaches = {};
  const printBtn = document.querySelector("#wb-print");
  const toggleQuickviewBtn = document.querySelector("#wb-toggle-quickview");
  const closeQuickviewBtn = document.querySelector("#wb-close-quickview");
  const addToCartBtn = document.querySelector("#wb-add-to-cart");
  const printPreview = document.createElement("div");
  const prevBtn = document.querySelector(
    ".wb-slider .flickity-prev-next-button.previous"
  );
  const nextBtn = document.querySelector(
    ".wb-slider .flickity-prev-next-button.next"
  );

  let page = 1;
  let fetching = false;
  const basePixels = 100;

  /** @type {Array<{id: string, count: number}>} */
  const selectedProducts = [];

  const pckry = new Packery(dropzones, {
    // options
    itemSelector: ".wb-draggable",
    gutter: 10,
    columnWidth: 100,
  });

  function renderPrintPreviewContainer() {
    printPreview.className = "wb-print-preview hidden";
    const content = document.createElement("div");
    content.className = "wb-print-preview-content";
    printPreview.appendChild(content);

    const actions = document.createElement("div");
    actions.className = "wb-print-preview-actions";

    const closePrintPreviewBtn = document.createElement("button");
    closePrintPreviewBtn.className = "btn btn--outline";
    closePrintPreviewBtn.textContent = "Close";
    closePrintPreviewBtn.addEventListener("click", () => {
      printPreview.classList.add("hidden");
      document.body.classList.remove("wb-open");
    });
    actions.appendChild(closePrintPreviewBtn);
    const printBtn = document.createElement("button");
    printBtn.className = "btn btn--primary";
    printBtn.textContent = "Print";
    printBtn.addEventListener("click", () => {
      window.print();
    });
    actions.appendChild(printBtn);

    printPreview.appendChild(actions);

    document.body.appendChild(printPreview);
  }

  function createImage(product, width = basePixels, multiplier = 2) {
    const img = document.createElement("img");
    img.alt = product.title;
    if (product.featured_image.aspect_ratio < 1) {
      img.width = width;
      img.height = Math.ceil(width / product.featured_image.aspect_ratio);
    } else {
      img.width = Math.ceil(width * product.featured_image.aspect_ratio);
      img.height = width;
    }
    const lastIndex = product.featured_image.url.lastIndexOf(".");
    img.src =
      product.featured_image.url.slice(0, lastIndex) +
      `_${img.width * multiplier}x` +
      product.featured_image.url.slice(lastIndex);
    return img;
  }

  function renderSlides(products) {
    // then render new slides
    for (const product of products) {
      if (product.type !== "Prints") continue;

      const slide = document.createElement("button");
      slide.className = "wb-slide";
      slide.dataset.productId = product.id;

      const img = createImage(product);
      slide.appendChild(img);

      const small = document.createElement("small");
      small.textContent = product.title;
      slide.appendChild(small);

      const overlay = document.createElement("div");
      overlay.className = "wb-slide-overlay";
      slide.appendChild(overlay);

      const countSpan = document.createElement("span");
      countSpan.className = "wb-slide-count";
      const existingCount = selectedProducts.find(
        (p) => p.id === product.id
      )?.count;
      countSpan.textContent = existingCount || "";
      overlay.appendChild(countSpan);
      if (existingCount) {
        slide.classList.add("selected");
      }

      const plusBtn = document.createElement("span");
      plusBtn.className = "btn btn--small";
      plusBtn.innerHTML = "+";
      overlay.appendChild(plusBtn);

      const spanPH = document.createElement("span");
      spanPH.textContent = "";
      overlay.appendChild(spanPH);

      slide.addEventListener("click", () => {
        canvas.classList.add("has-products");
        const index = selectedProducts.findIndex((p) => product.id === p.id);
        if (index === -1) {
          selectedProducts.push({
            id: product.id,
            count: 1,
          });
          countSpan.textContent = 1;
        } else {
          selectedProducts[index].count++;
          countSpan.textContent = selectedProducts[index].count;
        }
        slide.classList.add("selected");

        addImageToCanvas(slide, countSpan, img);

        const totalItems = selectedProducts.reduce(
          (acc, product) => acc + product.count,
          0
        );
        let cols = 3;
        if (totalItems >= 4) {
          cols = 5;
        } else if (totalItems >= 3) {
          cols = 4;
        }
        if (totalItems > 0) {
          printBtn.disabled = false;
          toggleQuickviewBtn.disabled = false;
        } else {
          printBtn.disabled = true;
          toggleQuickviewBtn.disabled = true;
        }
        dropzones.style.width = `${img.width * cols + 11 * (cols - 1)}px`;
        pckry.shiftLayout();
        // also exit out of quickview if it's open
        closeQuickviewBtn.click();
      });
      slider.appendChild(slide);
    }
  }

  // Add image to canvas
  function addImageToCanvas(slide, countSpan, img) {
    const div = document.createElement("div");
    div.className = "wb-draggable";
    div.style.width = `${img.width}px`;
    div.style.height = `${img.height}px`;
    div.dataset.productId = slide.dataset.productId;
    dropzones.appendChild(div);

    const draggableImage = document.createElement("img");
    draggableImage.src = img.src;
    div.appendChild(draggableImage);

    const btn = document.createElement("button");
    btn.className = "btn btn--small";
    btn.innerHTML = "x";
    
    // Function to handle remove action
    const handleRemove = (e) => {
      e.stopPropagation();
      e.preventDefault();
      const index = selectedProducts.findIndex(
        (product) => product.id === slide.dataset.productId
      );
      if (index !== -1) {
        selectedProducts[index].count--;
        if (selectedProducts[index].count === 0) {
          selectedProducts.splice(index, 1);
          countSpan.textContent = "";
          slide.classList.remove("selected");
        } else {
          countSpan.textContent = selectedProducts[index].count;
        }
        pckry.remove(div);
        pckry.shiftLayout();
      }

      const totalItems = selectedProducts.reduce(
        (acc, product) => acc + product.count,
        0
      );
      if (totalItems > 0) {
        printBtn.disabled = false;
        toggleQuickviewBtn.disabled = false;
      } else {
        printBtn.disabled = true;
        toggleQuickviewBtn.disabled = true;
      }
    };
    
    // Add both click and touch event handlers
    btn.addEventListener("click", handleRemove);
    
    // Handle touch events specifically for mobile
    btn.addEventListener("touchstart", (e) => {
      e.stopPropagation();
    }, { passive: false });
    
    btn.addEventListener("touchend", (e) => {
      e.stopPropagation();
      e.preventDefault();
      handleRemove(e);
    }, { passive: false });
    
    // Prevent dragging when touching the button 
    btn.addEventListener("mousedown", (e) => {
      e.stopPropagation();
    });
    
    btn.addEventListener("pointerdown", (e) => {
      e.stopPropagation();
    });
    
    div.appendChild(btn);

    const draggie = new Draggabilly(div);
    pckry.appended(div);
    pckry.bindDraggabillyEvents(draggie);
  }

  function mapProducts() {
    return Object.values(collectionCaches)
      .map((c) => c.products)
      .flat();
  }
  
  function getProducts(collectionHandle) {
    if (
      collectionCaches[collectionHandle] &&
      !collectionCaches[collectionHandle].hasMore
    ) {
      renderSlides(collectionCaches[collectionHandle].products);
      return;
    }

    if (fetching) return;
    fetching = true;

    fetch(`/collections/${collectionHandle}?view=json&page=${page}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (collectionCaches[collectionHandle]) {
          collectionCaches[collectionHandle].products.push(...data);
          collectionCaches[collectionHandle].hasMore = data.length === 50;
        } else {
          collectionCaches[collectionHandle] = {
            hasMore: data.length === 50, // if data is empty, then we don't have more products
            products: data,
          };
        }
        renderSlides(data); // render only new products
      })
      .finally(() => {
        fetching = false;
        page++;
      });
  }

  collectionsDDL.addEventListener("change", (e) => {
    const selectedCollection = e.target.value.split(":");
    collectionTitle.textContent = selectedCollection[1];
    page = 1; // reset page to 1 for new collection
    slider.innerHTML = ""; // also clear slider
    getProducts(selectedCollection[0]);
  });

  toggleQuickviewBtn.addEventListener("click", () => {
    const products = mapProducts().filter((p) =>
      selectedProducts.some((sp) => sp.id === p.id)
    );
    const content = quickview.querySelector(".wb-quickview-content");
    content.innerHTML = "";
    // group by product with same size and frame options (variant.option1 & variant.option2)
    const groupBy = products.reduce((acc, product) => {
      const _options1 = product.variants
        .map((v) => `${v.option1}:${v.option2}`)
        .filter((v, i, arr) => arr.indexOf(v) === i)
        .sort();
      const key = _options1.join("|");
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(product);
      return acc;
    }, {});

    for (const group in groupBy) {
      const div = document.createElement("div");
      div.className = "wb-product";
      const images = document.createElement("div");
      images.className = "wb-product-images";
      div.appendChild(images);

      const imagesGroup = selectedProducts.filter((p) =>
        groupBy[group].some((gp) => gp.id === p.id)
      );

      for (const imgkey of imagesGroup) {
        const imgDiv = document.createElement("div");
        const img = createImage(products.find((p) => p.id === imgkey.id));
        imgDiv.appendChild(img);
        const qty = document.createElement("span");
        qty.className = "wb-slide-count";
        qty.textContent = imgkey.count;
        imgDiv.appendChild(qty);
        images.appendChild(imgDiv);
      }
      const options = document.createElement("div");
      options.className = "wb-product-options";
      const option1DDL = document.createElement("select");
      const option2DDL = document.createElement("select");
      option2DDL.className = "wb-option2";
      option2DDL.dataset.productIds = groupBy[group]
        .map((p) => p.id)
        .filter((v, i, arr) => arr.indexOf(v) === i)
        .join(",");
      const firstProduct = groupBy[group][0];
      const variantOptions = firstProduct.variants
        .map((v) => `${v.option1}:${v.option2}`)
        .filter((v, i, arr) => arr.indexOf(v) === i);
      const option1Values = variantOptions
        .map((o) => o.split(":")[0])
        .filter((v, i, arr) => arr.indexOf(v) === i);
      option1DDL.innerHTML = option1Values
        .map((o) => `<option value='${o}'>${o}</option>`)
        .join("");
      option1DDL.addEventListener("change", (e) => {
        const option1 = e.target.value;
        const option2Values = variantOptions.filter(
          (o) => o.split(":")[0] === option1
        );
        option2DDL.dataset.option1 = option1;
        option2DDL.innerHTML = option2Values
          .map(
            (o) =>
              `<option value='${o.split(":")[1]}'>${o.split(":")[1]}</option>`
          )
          .join("");
      });
      option2DDL.dataset.option1 = option1Values[0];
      option2DDL.innerHTML = variantOptions
        .filter((o) => o.split(":")[0] === option1Values[0])
        .map(
          (o) =>
            `<option value='${o.split(":")[1]}'>${o.split(":")[1]}</option>`
        )
        .join("");
      options.appendChild(option1DDL);
      options.appendChild(option2DDL);
      div.appendChild(options);
      content.appendChild(div);
    }
    canvas.classList.add("hidden");
    quickview.classList.remove("hidden");
  });

  closeQuickviewBtn.addEventListener("click", () => {
    canvas.classList.remove("hidden");
    quickview.classList.add("hidden");
  });

  printBtn.addEventListener("click", () => {
    document.body.classList.add("wb-open");

    const multiplier = 5;
    const draggableItems = pckry.getItemElements();
    if (draggableItems.length === 0) return; // Nothing to print

    // First, collect positions and calculate bounding box
    const itemsData = [];
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    for (const item of draggableItems) {
      const productId = item.dataset.productId;
      const product = mapProducts().find((p) => p.id === productId);
      if (!product) continue;

      let width, height;
      if (product.featured_image.aspect_ratio < 1) {
        width = basePixels * multiplier;
        height = Math.ceil(
          (basePixels * multiplier) / product.featured_image.aspect_ratio
        );
      } else {
        width = Math.ceil(
          basePixels * multiplier * product.featured_image.aspect_ratio
        );
        height = basePixels * multiplier;
      }

      let left = parseInt(item.style.left) * multiplier;
      let top = parseInt(item.style.top) * multiplier;

      minX = Math.min(minX, left);
      minY = Math.min(minY, top);
      maxX = Math.max(maxX, left + width);
      maxY = Math.max(maxY, top + height);

      itemsData.push({ product, left, top, width, height });
    }

    let canvasWidth = maxX - minX;
    let canvasHeight = maxY - minY;

    if (canvasWidth <= 0 || canvasHeight <= 0) return; // Invalid dimensions

    const padding = 100;
    canvasWidth += 2 * padding;
    canvasHeight += 2 * padding;

    // Create canvas with calculated size including padding
    const canvas2d = document.createElement("canvas");
    canvas2d.width = canvasWidth;
    canvas2d.height = canvasHeight;
    const ctx = canvas2d.getContext("2d");

    // Set background to white
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas2d.width, canvas2d.height);

    // Load all images
    let loadedCount = 0;
    const totalItems = itemsData.length;

    itemsData.forEach(({ product, left, top, width, height }) => {
      const img = new Image();
      img.width = width;
      img.height = height;
      const lastIndex = product.featured_image.url.lastIndexOf(".");
      img.src =
        product.featured_image.url.slice(0, lastIndex) +
        `_${width}x` +
        product.featured_image.url.slice(lastIndex);

      img.onload = () => {
        ctx.drawImage(
          img,
          left - minX + padding,
          top - minY + padding,
          width,
          height
        );
        loadedCount++;
        if (loadedCount === totalItems) {
          // All images loaded, generate the final image
          const image = new Image();
          image.src = canvas2d.toDataURL("image/jpeg");
          printPreview.querySelector(".wb-print-preview-content").innerHTML =
            "";
          printPreview
            .querySelector(".wb-print-preview-content")
            .appendChild(image);
          printPreview.classList.remove("hidden");
          setTimeout(window.print, 100);
        }
      };
    });
  });

  addToCartBtn.addEventListener("click", () => {
    const products = mapProducts().filter((p) =>
      selectedProducts.some((sp) => sp.id === p.id)
    );

    const options2 = document.querySelectorAll(".wb-option2");
    const items = [];
    for (const option2 of options2) {
      const productIds = option2.dataset.productIds.split(",");
      const productsToAdd = products.filter((p) => productIds.includes(p.id));
      for (const product of productsToAdd) {
        const variant = product.variants.find(
          (v) =>
            v.option1 === option2.dataset.option1 && v.option2 === option2.value
        );
        if (variant) {
          items.push({
            id: variant.id,
            quantity: selectedProducts.find((sp) => sp.id === product.id).count,
          });
        }
      }
    }

    window.cart.addToCart(JSON.stringify({ items }), null, addToCartBtn);
  });

  prevBtn.addEventListener("click", () => {
    slider.scrollBy({ left: -100, behavior: "smooth" });
  });

  nextBtn.addEventListener("click", () => {
    slider.scrollBy({ left: 100, behavior: "smooth" });
  });

  slider.addEventListener("scroll", () => {
    const scrollLeft = slider.scrollLeft;
    const scrollWidth = slider.scrollWidth;
    const clientWidth = slider.clientWidth;
    // get more products when scroll is near 20% to the end
    const nearEnd = scrollLeft + clientWidth >= scrollWidth - scrollWidth * 0.2;
    const selectedCollection = collectionsDDL.value.split(":");
    const collection = collectionCaches[selectedCollection[0]];
    if (nearEnd && (!collection || collection.hasMore)) {
      getProducts(selectedCollection[0]);
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    renderPrintPreviewContainer();
    // get selected dropdown value then get products from that collection
    const selectedCollection = collectionsDDL.value.split(":");
    getProducts(selectedCollection[0]);
  });
})();
